function findStyleElement(input, classPrefix = "css-") {
    if (typeof input === "string")
        return document.getElementById(input);
    const className = [...input.classList].find((name) => name.startsWith(classPrefix));
    if (className)
        return document.getElementById(className.slice(classPrefix.length));
}
export default findStyleElement;
